/*
 * Quién pide esconder el botón flotante de Guías.
 *
 * Lo piden dos sitios a la vez: el asistente de configuración mientras está
 * abierto, y `VideoGuides` cada vez que detecta un overlay (un drawer, un modal
 * de PrimeVue…). La marca en el <body> es un sí/no, así que el primero en
 * soltarla se llevaba por delante la petición del otro: bastaba abrir y cerrar
 * el modal de credenciales DENTRO del asistente para que el botón reapareciera
 * flotando encima del asistente.
 *
 * Se cuenta en vez de encender y apagar: el botón vuelve cuando ya no lo pide
 * nadie, no cuando el primero termina.
 */
const MARCA = 'wac-hide-fab';
let peticiones = 0;

function aplicar() {
  try {
    document.body.classList.toggle(MARCA, peticiones > 0);
  } catch (e) {
    /* Sin <body> (pruebas, render en servidor) no hay nada que esconder. */
  }
}

/** Pide esconder el botón. Recuerda llamar a `mostrarFab` al terminar. */
export function ocultarFab() {
  peticiones += 1;
  aplicar();
}

/** Retira UNA petición. El botón sólo vuelve si no queda ninguna. */
export function mostrarFab() {
  peticiones = Math.max(0, peticiones - 1);
  aplicar();
}
